"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appAlipayLogin = appAlipayLogin;
var _fetch = _interopRequireDefault(require("@/utils/fetch"));
/**
 *  app登录
 */
// app登录授权
function appAlipayLogin(params) {
  return _fetch.default.post("/Supplier/appAlipayLogin", params);
}